import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';
import Spinner from '../../../customers/customersList/spinner';
import { PureDebitCardForm as DebitCardForm } from '../../debitCard/Form';

const showCard = ({ paymentCard, updateCard, formIsOn, formOff, formOn, loadingIsOn, currency }) => {
  return (
    <div display-if={paymentCard}>
      <div display-if={paymentCard.paymentCustomerChangeRequired} className="s-v2 u-ph- u-pb- u-text-center">
        <span className="u-co-red u-type--semibold">
          {t('settings:payment_card.subscription_reentry_message', { currency: currency.toUpperCase() })}
        </span>
      </div>
      <h5>{t('settings:payment_card.credit_card_subscription')}</h5>
      <div display-if={!formIsOn} className="o-flexbox">
        <div className="o-flexbox__item o-flexbox__item--flex-start">
          <div className="c-heading c-heading--small c-heading--dark">
            {t('settings:payment_card.number_label')}: ************{paymentCard.details.last4}
          </div>
          <div className="c-heading c-heading--small c-heading--dark">
            {t('settings:payment_card.expiration_label')}: {paymentCard.details.exp_month}/
            {paymentCard.details.exp_year}
          </div>
        </div>
        <div className="o-flexbox__item">
          <button className="c-btn u-width-120" onClick={formOn}>
            {t('common:buttons.update')}
          </button>
        </div>
      </div>
      <div display-if={formIsOn}>
        <div className="u--mt- u-mb u-text-center u-height-50">
          <div className="u-inline-block">
            <Spinner display-if={loadingIsOn} />
          </div>
        </div>
        <DebitCardForm form="creditCard" save={updateCard} cancel={formOff} />
      </div>
    </div>
  );
};

showCard.propTypes = {
  paymentCard: PropTypes.object,
  updateCard: PropTypes.func.isRequired,
  formOn: PropTypes.func.isRequired,
  formOff: PropTypes.func.isRequired,
  formIsOn: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
};
showCard.defaultProps = {
  paymentCard: false,
};

export default showCard;
